import { ReactNode } from 'react'

import { Box } from '@factorialco/deprecated-design-system'
import {
  FilterType,
  FormsFormStatusEnum,
  buildTrainingFormsDatatableFilter,
  useTrainingFormsDatatable,
} from 'generated/resources/datatable.graphql'

import i18n from 'modules/core/lib/i18n'

import { FormStatusTag } from '../FormStatusTag'

type Option = {
  label: string
  value: FormsFormStatusEnum
  component: ReactNode
}
export const statusFilter = (source: ReturnType<typeof useTrainingFormsDatatable>) => {
  const options: Option[] = [
    {
      label: i18n.t('trainings.surveys.status.draft'),
      value: 'draft',
      component: (
        <Box>
          <FormStatusTag formStatus="draft" />
        </Box>
      ),
    },
    {
      label: i18n.t('trainings.surveys.status.published'),
      value: 'active',
      component: (
        <Box>
          <FormStatusTag formStatus="active" />
        </Box>
      ),
    },
  ]

  return buildTrainingFormsDatatableFilter(source, {
    identifier: 'status_filter',
    title: i18n.t('trainings.surveys.status.filter_title'),
    default: true,
    path: 'status',
    type: FilterType.String,
    categories: [{ kind: 'SingleChoice', operation: 'eq', options }],
  })
}
